import { Component, OnInit } from '@angular/core';

import { ColorService } from '../../../../core/services/color.service';

import { HttpTrainingSessionService } from '../../../../core/services/http/http-training-session.service';
import { TrainingStatistics } from '../../../models/entities/training-session.entity';

declare var ProgressBar: any;

@Component({
  selector: 'app-progress-custom-training-card',
  templateUrl: './progress-custom-training-card.component.html',
  styleUrls: ['./progress-custom-training-card.component.scss'],
})
export class ProgressCustomTrainingCardComponent implements OnInit {
  trainingStatistics: TrainingStatistics;

  svgQuestionsPartiallyCorrect;
  svgQuestionsCorrect;

  constructor(
    private colorService: ColorService,
    private httpTrainingSessionService: HttpTrainingSessionService
  ) {}

  ngOnInit(): void {}

  loadComponent() {
    this.httpTrainingSessionService.getStats().subscribe((res) => {
      this.trainingStatistics = new TrainingStatistics(res);

      setTimeout(() => {
        if (
          ProgressBar &&
          document.getElementById('svg_questionsPartiallyCorrect') &&
          document.getElementById('svg_questionsCorrect')
        ) {
          const trailColor = this.colorService.getAppRed();

          this.svgQuestionsPartiallyCorrect = new ProgressBar.Circle(
            '#svg_questionsPartiallyCorrect',
            {
              color: this.colorService.getAppOrangeTwo(),
              trailColor,
              strokeWidth: 7,
            }
          );

          this.svgQuestionsCorrect = new ProgressBar.Circle('#svg_questionsCorrect', {
            color: this.colorService.getAppGreenThree(),
            trailColor: 'transparent',
            strokeWidth: 7,
          });

          this.svgQuestionsPartiallyCorrect.animate(
            (this.trainingStatistics.totalPartiallyCorrectlyAnsweredQuestions +
              this.trainingStatistics.totalCorrectlyAnsweredQuestions) /
              this.trainingStatistics.totalAnsweredQuestions
          );

          this.svgQuestionsCorrect.animate(
            this.trainingStatistics.totalCorrectlyAnsweredQuestions /
              this.trainingStatistics.totalAnsweredQuestions
          );
        }
      });
    });
  }
}
